import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { firestoreConnect, isEmpty, isLoaded } from "react-redux-firebase"
import { compose } from "redux"
import Presentation from "./Presentation"
import {
  addSectionToPlacement,
  updatePlacement,
} from "../../../../../middleware"
import CircularSpinner from "../../../../../../../shared/circularSpinner"

function Container(props) {
  const {
    clientDetails_data,
    placement,
    profile,
    clients,
    addSectionToPlacement,
    updatePlacement,
  } = props
  const initState = {
    value: 0,
    tabList: [],
    fillableSections: [],
    id: "",
    employeeID: profile.uid,
    tabValue:{}
  }
  const [state, setState] = useState(initState)
  console.log(clientDetails_data, placement);
  useEffect(() => {
    if (isLoaded(clientDetails_data) && !isEmpty(clientDetails_data)) {
      let placementData = Object.entries(clientDetails_data.clients).map(([key, value]) => {
        return {
          ...value,
          isDraft: false,
        }
      })
      let firstTab = placementData.filter((placement) => placement.clientType === "Billable Client")
      let remainingTabs = placementData.filter(
        (placement) => placement.clientType !== "Billable Client"
      )
      let tabList = [...firstTab, ...remainingTabs].map((placement, index) => {
        return {
          ...placement,
          key: index,
          id: index,
          selectAddressList: [],
        }
      })
      console.log(tabList)
      setState((prevState) => ({
        ...prevState,
        tabList,
      }))
    } else {
      setState((prevState) => ({
        ...prevState,
        tabList: [
          {
            key: 0,
            id: 0,
            clientId: placement.clientId,
            workLocation: false,
            clientType: "Billable Client",
            selectAddress: "",
            subContracting: "",
            contingencyinPayment: "",
            prohibitionPeriod: "",
            rightToHire: "",
            liquidatedDamages: "",
            identification: "",
            comments: "",
            selectAddressList: [],
            isDraft: true,
          },
        ],
      }))
    }
    setState((prevState) => ({
      ...prevState,
      fillableSections: placement.fillableSections,
      id: placement.id,
      tabValue:state.tabList[state.value]
    }))
    //return () => setState(() => ({ ...initState }))
  }, [clientDetails_data, JSON.stringify(placement)])

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      tabValue:state.tabList[state.value]
    }))
  },[JSON.stringify(state.tabList)])

  const addTab = () => {
    const { tabList } = state
    let id = tabList[tabList.length - 1].id + 1
    let data = tabList
    let newTab = {
      key: id,
      id: id,
      clientId: "",
      workLocation: false,
      clientType: "",
      selectAddress: "",
      subContracting: "",
      contingencyinPayment: "",
      prohibitionPeriod: "",
      rightToHire: "",
      liquidatedDamages: "",
      identification: "",
      comments: "",
      selectAddressList: [],
      isDraft: true,
    }
    data = [...data, newTab]
    setState({ ...state, tabList: data })
  }

  const deleteTab = (e,tab_id) => {
    e.stopPropagation()
    if (state.tabList.length === 1) {
      return
    }
    let tabID = parseInt(tab_id)
    let tabIDIndex = 0
    let tabList = state.tabList.filter((value, index) => {
      if (value.id === tabID) {
        tabIDIndex = index
      }
      return value.id !== tabID
    })
    if (tabIDIndex === 0) {
      return
    }
    if (!state.tabList[tabIDIndex].isDraft) {
      updatePlacement(
        {
          delete: true,
          clientId: state.tabList[tabIDIndex].clientId,
        },
        "client_details",
        state.employeeID,
        state.id
      )
    }
    let curValue = parseInt(state.value)
    if (curValue === tabID) {
      if (tabIDIndex === 0) {
        curValue = state.tabList[tabIDIndex + 1].id
      } else {
        curValue = state.tabList[tabIDIndex - 1].id
      }
    }else{
      curValue = state.tabList[tabIDIndex - 1].id
    }
    setState((prevState) => ({
      ...prevState,
      value: curValue,
    }))
    setState((prevState) => ({
      ...prevState,
      tabList: tabList,
    }))
  }

  const handleSubmit = (e) => {
    //props.handleChange("panel5")
    e.preventDefault()
    let payload = {}
    const { closeTab } = props
    state.tabList.forEach((tab) => {
      payload[tab.clientId] = {
        clientId: tab.clientId,
        workLocation: tab.workLocation,
        clientType: tab.clientType,
        selectAddress: tab.selectAddress,
        subContracting: tab.subContracting,
        contingencyinPayment: tab.contingencyinPayment,
        prohibitionPeriod: tab.prohibitionPeriod,
        rightToHire: tab.rightToHire,
        liquidatedDamages: tab.liquidatedDamages,
        identification: tab.identification,
        comments: tab.comments,
      }
    })
    console.log(payload)
    if (isLoaded(clientDetails_data) && isEmpty(clientDetails_data)) {
      addSectionToPlacement(
        { clients: payload },
        "client_details",
        state.employeeID,
        state.id,
        closeTab
      )
    } else {
      console.log("update")
      updatePlacement(
        { clients: payload },
        "client_details",
        state.employeeID,
        state.id,
        closeTab
      )
    }
  }

  const handleChange = (tabList) => {
    setState({
      ...state,
      tabList,
    })
  }

  const handleTabChange = (event, value) => {
    setState({ ...state, value,tabValue:state.tabList[value] })
  }

  if (isLoaded(clientDetails_data)) {
    console.log("--------------CLIENT DETAILS---------------");
    return (
      <Presentation
        {...state}
        closeTab={props.closeTab}
        handleChange={handleChange}
        handleTabChange={handleTabChange}
        addTab={addTab}
        deleteTab={deleteTab}
        handleSubmit={handleSubmit}
        clients={clients}
        employeeCategory={profile.category}
      />
    )
  }

  return (
   <CircularSpinner/>
  )
}

const mapStateToProps = (state, ownProps) => {
  const { data } = state.firestore
  return {
    clientDetails_data: data.clientDetails_data,
    clients: data.clients_meta_info ? data.clients_meta_info : {},
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addSectionToPlacement: (payload, sectionName, uid, placementID, closeTab) => {
      dispatch(addSectionToPlacement(payload, sectionName, uid, placementID, closeTab))
    },
    updatePlacement: (payload, sectionName, uid, placementID, closeTab) => {
      dispatch(updatePlacement(payload, sectionName, uid, placementID, closeTab))
    },
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    const { placement } = props
    if (!placement.id) return []
    return [
      {
        collection: "EMPLOYEES",
        doc: placement.employeeID,
        subcollections: [
          {
            collection: "PLACEMENTS",
            doc: placement.id,
            subcollections: [
              {
                collection: "SETTINGS",
                doc: "client_details",
                storeAs: "clientDetails",
              },
            ],
            storeAs: "placement_clientDetails",
          },
        ],
        storeAs: "clientDetails_data",
      },
    ]
  })
)(Container)
